import ReactMarkdown from 'react-markdown';
import './ChatMarkdown.css';

const MessageBubble = ({ 
  message, 
  primaryColor, 
  secondaryColor, 
  getContrastColor,
  isLastInSequence,
  agentName,
  agentLogo,
  chatState
}) => {
  const linkifyText = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 underline hover:text-blue-300 break-all"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };
  if (message.text === "" || message.text === undefined) {
    return <></>
  }

  message.text = message.text.replace("---", "")

  if (message.type === 'system') {
    return (
      <div className="flex justify-center">
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 max-w-[90%]">
          <p className="text-sm">{message.text}</p>
        </div>
      </div>
    );
  }

  const isUser = message.type === 'user';
  const bgColor = isUser ? primaryColor : '#FFFFFF';
  const textColor = isUser ? getContrastColor(primaryColor) : '#000000ff';

  return (
    <div className={`flex gap-2 ${isUser ? 'justify-end' : 'justify-start'} mb-1`}>
      {/* Avatar apenas na última mensagem da sequência */}
      {!isUser && (
        <div className="flex-shrink-0" style={{ width: '24px' }}>
          {isLastInSequence && (
            <img 
              src={agentLogo} 
              alt={agentName}
              className="w-6 h-6 rounded-full"
            />
          )}
        </div>
      )}

      <div className="flex flex-col max-w-[75%]">
        <div
          className="rounded-lg px-4 py-2.5 shadow-sm relative"
          style={{
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: isUser ? '12px 12px 0 12px' : '12px 12px 12px 0'
          }}
        >

          {!isUser ? (
            <div className="markdown-content-chat text-sm">
              <ReactMarkdown
                components={{
                  img: ({ node, ...props }) => {
                    if (props.src && props.src.includes('oaidalleapiprodscus')) {
                      return null;
                    }
                    return (
                      <img 
                        className="max-w-[200px] max-h-[150px] object-cover rounded-lg my-2 shadow-sm cursor-pointer hover:shadow-md transition-shadow" 
                        {...props} 
                        alt={props.alt || 'imagem'}
                        onClick={(e) => {
                          window.open(props.src, '_blank');
                        }}
                      />
                    );
                  },
                  a: ({ node, ...props }) => {
                    if (props.href && props.href.includes('oaidalleapiprodscus')) {
                      return null;
                    }
                    return (
                      <a 
                        className="text-blue-600 underline hover:text-blue-700 break-all" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        {...props} 
                      />
                    );
                  },
                  p: ({ node, children, ...props }) => {
                    const textContent = node.children
                      .filter(child => child.type === 'text')
                      .map(child => child.value)
                      .join('');
                    
                    if (textContent && /(https?:\/\/[^\s\]]+)/.test(textContent)) {
                      return (
                        <p className="mb-1 last:mb-0" {...props}>
                          {node.children.map((child, index) => {
                            if (child.type === 'text') {
                              return <span key={index}>{linkifyText(child.value)}</span>;
                            }
                            return children[index];
                          })}
                        </p>
                      );
                    }
                    
                    return <p className="mb-1 last:mb-0" {...props}>{children}</p>;
                  },
                  h1: ({ node, ...props }) => <h1 className="text-base font-bold mb-2 mt-2" {...props} />,
                  h2: ({ node, ...props }) => <h2 className="text-sm font-bold mb-1 mt-2" {...props} />,
                  h3: ({ node, ...props }) => <h3 className="text-sm font-semibold mb-1 mt-1" {...props} />,
                  ul: ({ node, ...props }) => <ul className="list-disc ml-4 mb-2 space-y-1" {...props} />,
                  ol: ({ node, ...props }) => <ol className="list-decimal ml-4 mb-2 space-y-1" {...props} />,
                  li: ({ node, ...props }) => <li className="text-sm" {...props} />,
                  blockquote: ({ node, ...props }) => (
                    <blockquote 
                      className="border-l-2 pl-3 italic my-2 opacity-90" 
                      style={{ borderLeftColor: textColor }}
                      {...props} 
                    />
                  ),
                  code: ({ node, inline, ...props }) => 
                    inline ? 
                      <code 
                        className="px-1.5 py-0.5 rounded text-xs font-mono bg-gray-100"
                        {...props} 
                      /> :
                      <code 
                        className="block p-2 rounded my-2 overflow-x-auto text-xs font-mono bg-gray-100"
                        {...props} 
                      />,
                  pre: ({ node, ...props }) => (
                    <pre 
                      className="p-2 rounded my-2 overflow-x-auto text-xs bg-gray-100"
                      {...props} 
                    />
                  )
                }}
              >
                {message.text}
              </ReactMarkdown>
            </div>
          ) : (
            <div className="text-sm whitespace-pre-line">
              {linkifyText(message.text)}
            </div>
          )}
        </div>

        {/* Nome do agente apenas na última mensagem */}
        {!isUser && isLastInSequence && (
          <span className="text-xs text-gray-500 mt-1 ml-1">{
            chatState === "paused" ? "Atendente da equipe" : agentName
          }</span>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;